import { Component, OnInit,ElementRef,ViewChild } from '@angular/core';
import { MasterService,FeecounterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
@Component({
  selector: 'app-rootallot',
  templateUrl: './rootallot.component.html',
  styleUrls: ['./rootallot.component.scss'],
   providers:[MasterService,FeecounterService,ClassroomService]
})
export class RootallotComponent implements OnInit {
  arrbatch: any;
  arrstutrans: any;
  objmethod:any = {};

  constructor(private http: HttpClient,private cservice: ClassroomService,private aservice:FeecounterService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
   sections:any=[];
   classes:any=[];
   arrstudent:any=[];
   fmodel:any={clid:'0',scid:'0',subid:'0',prid:'0'};
   tmodel:any={clid:'0',scid:'0',crid:'0',baid:'0'};
   fmodel1:any={clid:'0',secid:'0',accatid:'0',prid:'0'};
   arrrepdata:any=[];
   arrper:any=[];
   arrrechead:any=[];
   arrastype:any=[];
   arracchead:any=[];
   recdetails:any=[];
   arrcol:any=[];
   accat:any=[];
   arrfeerech:any=[];
   objvhead:any={};
   objfcol:any={};
   oprtype:any='';
   oprtype1:any='';
   tabledata: any = {};
   ttldfeamt=0;
   arrfeesum:any=[];
   showload='No';
   sertxt:any="";
   catid:any;
   arrcourse:any=[];
   arfeequota1:any=[];
   arfeequota:any=[];
   arfeequotatp:any=[];
   arfeequotahs:any=[];
   arpayopt:any=[];
   arropted=[{name:'Yes'},{name:'No'}];
   modalOptions:NgbModalOptions;
 
   modalOptions1:NgbModalOptions;
   private modalRef: NgbModalRef;
   private modalRef1: NgbModalRef;
 
 
 
   ngOnInit(): void {
     
     
     //this.masmot();
     this.getcourses();
     this.selbatch();
    
 
   }
 
  
 selbatch()
{
  debugger
  this.mservice.selbatch()
  .subscribe(
  resultArray =>{
    console.log('sub-result', resultArray);
    this.arrbatch=resultArray;
    //this.objfilt.baid=resultArray[0].baid;
    },
error => console.log("Error :: " + error)
)
}


 openmethod(content,objdata,cmd) {
      debugger
      if(cmd=='insert')
      {
        this.objmethod={};
       
        
        
        this.objmethod.baid='0';
        this.objmethod.banm='';
        this.objmethod.bacd='';
         this.objmethod.active='Yes';
        // this.objastype.suid=this.objfilt.suid;
        // this.objsubcat.subcacd='';
        //this.objsubcat.subcanm='';
        this.objmethod.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
        this.objmethod=objdata;
        this.objmethod.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
   

    
  save_obemtmethod()
  {
  console.log('saveobj',this.objmethod);
    this.mservice.save_evlmbatch(this.objmethod)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
            //  this.masasstype();
           this.selbatch();
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }
   
   private getcourses() {
 
     this.mservice.getcourse()
   .subscribe((result:any) => {
   
   this.arrcourse=result;
   this.fmodel.crid=result[0].crid;
   this.masclass();
   
   }, error => {
   
   //alert('error in r');
   // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
   }
   );
     
     
   }
 
   updatepayopt(obj)
   {
 debugger
     if(confirm("Are you sure you want to modify details."))
     this.cservice.modifytransdet(obj)
         .subscribe(
         resultArray => {
             console.log('getdashcounts', resultArray);
             alert(resultArray.message);
            this.getstudentsdata('clswise');
         },
         error => console.log("Error :: " + error)
         )
   }
   
 
   masacccat() {
     debugger
     this.mservice.masacccat()
         .subscribe(
         resultArray => {
             console.log('getacccategory', resultArray);
             this.accat = resultArray;
             this.fmodel.accatid=resultArray[0].accatid;
            // this.catid=resultArray[0].accatid;
             //this.getrecdetails('selhtop20','',resultArray[0].accatid);
            
         },
         error => console.log("Error :: " + error)
         )
   }
 
 
   
 
   masclass() {
     this.mservice.masclass()
         .subscribe(
         resultArray => {
             console.log('getdashcounts', resultArray);
             this.classes = resultArray;
            this.fmodel.clid=resultArray[0].clid;
             this.massection();
             
             
            
         },
         error => console.log("Error :: " + error)
         )
   }
 
 
   massection() {
     this.mservice.massection()
         .subscribe(
         resultArray => {
             console.log('getdashcounts', resultArray);
             this.sections = resultArray;
             this.fmodel.scid=resultArray[0].scid;
             //this.by_sp_student();
            this.getrecdetails();
         },
         error => console.log("Error :: " + error)
         )
   }
 

     getstudentsdata(oprtype) {
        this.cservice.getstudents_bytype(this.fmodel.clid,this.fmodel.scid,this.fmodel.crid,oprtype,0)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);

                this.recdetails=resultArray;
                // this.arrstudent =  resultArray.filter(item => this.arrrepdata.find(y => y.stuid !== item.stuid));
                //                     //  jsonArray.filter((item) => filterArray.includes(item.id));
                console.log('bloodgp', this.arrstudent);
            },
            error => console.log("Error :: " + error)
            )
      }

         getstudents_trans(oprtype) {
        this.cservice.getstudents_trans(this.tmodel.clid,this.tmodel.scid,this.tmodel.crid,this.tmodel.baid,oprtype)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);

                this.arrstutrans=resultArray;
                // this.arrstudent =  resultArray.filter(item => this.arrrepdata.find(y => y.stuid !== item.stuid));
                //                     //  jsonArray.filter((item) => filterArray.includes(item.id));
                console.log('bloodgp', this.arrstudent);
            },
            error => console.log("Error :: " + error)
            )
      }
 
   getrecdetails()
 {
   debugger
  
 console.log('fmodel',this.fmodel);
    this.aservice.getvochersbyclass(this.fmodel)
   
   //this.acservice.Acreceiptheader('1','1',this.tempdbnm)
   .subscribe(
     
    resultArray =>{
     console.log('result',resultArray) ;
     
     this.recdetails = resultArray;
 
    
     },
    error => {console.log("Error :: " + error);
   
   alert('error while fetching results');}
 )
 
 }
 
 masfeequota() {
   this.mservice.masfeequota()
       .subscribe(
       resultArray => {
           console.log('getdashcounts', resultArray);
           this.arfeequota1 = resultArray;
           this.arfeequota = resultArray.filter(item=>item.accatid==1);
           this.arfeequotatp = resultArray.filter(item=>item.accatid==2);
           this.arfeequotahs = resultArray.filter(item=>item.accatid==5);
          
       },
       error => console.log("Error :: " + error)
       )
 }
 maspayopts() {
   this.mservice.maspayopt()
       .subscribe(
       resultArray => {
           console.log('maspayopt', resultArray);
           this.arpayopt = resultArray;
          
       },
       error => console.log("Error :: " + error)
       )
 }
 
 generate_student(obj,oprtype) {
   if(confirm("Are you sure you wan't to "+oprtype+" voucher"))
   this.aservice.generatevocher(obj,oprtype)
       .subscribe(
       resultArray => {
           console.log('getdashcounts', resultArray);
           alert(resultArray.message);
          this.getrecdetails();
       },
       error => console.log("Error :: " + error)
       )
 }
 }
 